export const ASSET_ORIGIN = process.env.NEXT_PUBLIC_ASSET_ORIGIN ?? 'https://image-nations-long-film-festivale.fly.dev';

const isAbsolute = (u: string) =>
  /^(https?:)?\/\//.test(u) || u.startsWith('data:') || u.startsWith('mailto:');

const ensureLeadingSlash = (value: string) => (value.startsWith('/') ? value : `/${value}`);

export const toAssetUrl = (src: string, _basePath?: string): string => {
  if (!src) return src;
  if (isAbsolute(src) || src.startsWith('#')) {
    return src;
  }

  const normalized = ensureLeadingSlash(src);
  return ASSET_ORIGIN ? `${ASSET_ORIGIN}${normalized}` : normalized;
};